// https://buefy.github.io/#/documentation/toast
<script>
export default {
  methods: {
    display_Success: function(msg) {
      this.$toast.open({
        message: msg,
        type: "is-success"
      });
    },
    display_Error: function(msg) {
      this.$toast.open({
        message: msg,
        type: "is-danger"
      });
    }
  }
};
</script>
